import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { lowerLanguage } from "src/i18n";
import { selectorDocuments } from "src/storage";

export const useAccessibility = () => {
  const { t } = useTranslation();
  const documents = useRecoilValue(selectorDocuments);
  const accessibilityLink = documents?.find(({ docCode }) => docCode === "9")
    ?.filePath?.[lowerLanguage];

  return { t, accessibilityLink };
};
